(function ($, Drupal) {
  Drupal.behaviors.scrollMenu = {
    attach: function (context) {
      once('scrollmenu', 'html', context).forEach(function (html) {
        const navigation = html.querySelector('#navigation');

        function scrollToAnchor(target) {
          if (target) {
            const menuHeight = navigation ? navigation.offsetHeight : 0;
            const offset = menuHeight + 126;
            const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth',
            });
          }
        }

        if (window.location.hash && window.location.hash !== '#') {
          const target = document.querySelector(window.location.hash);
          if (target) {
            setTimeout(() => {
              scrollToAnchor(target);
              window.history.replaceState(null, '', window.location.pathname);
            }, 100);
          }
        }

        const baseUrl = `${window.location.protocol}//${window.location.host}`;
        const currentUrl = new URL(window.location.href);

        document.querySelectorAll('[data-scroll-menu] a[href]').forEach((anchor) => {
          const targetUrl = new URL(anchor.getAttribute('href'), baseUrl);
          if (targetUrl.hash !== '' && targetUrl.hash !== '#') {
            anchor.addEventListener('click', function (e) {
              e.preventDefault();
              const currentBase = `${currentUrl.origin}${currentUrl.pathname}`;
              const targetBase = `${targetUrl.origin}${targetUrl.pathname}`;
              const scrollToElement = document.getElementById(targetUrl.hash.substring(1));

              if (currentBase === targetBase) {
                scrollToAnchor(scrollToElement);
                navigation.classList.remove('is-expanded');
              } else {
                window.location.href = targetUrl.toString();
              }
            });
          }
        });
      });
    },
  };
}(jQuery, Drupal));
